import { ADD_USER } from "../constants/userConstants";

export const addUser = user => ({
  type: ADD_USER,
  payload: user
});
